import { Terminator, VirtualObject } from "@opendaw/lib-std";
import { queueTask } from "@opendaw/lib-dom";
import { Communicator } from "@opendaw/lib-runtime";
export class PreferencesHost {
    #terminator = new Terminator();
    #object;
    constructor(settings) { this.#object = this.#terminator.own(new VirtualObject(settings)); }
    get settings() { return this.#object.proxy; }
    syncWith(messenger) {
        const client = Communicator.sender(messenger, ({ dispatchAndForget }) => new class {
            updateSettings(preferences) {
                dispatchAndForget(this.updateSettings, preferences);
            }
        });
        const queue = queueTask(() => client.updateSettings(this.#object.data));
        client.updateSettings(this.#object.data);
        return this.#object.subscribeAll(queue);
    }
    update(data) { this.#object.update(data); }
    subscribe(observer, ...path) {
        return this.#object.subscribe(observer, ...path);
    }
    catchupAndSubscribe(observer, ...path) {
        return this.#object.catchupAndSubscribe(observer, ...path);
    }
    createMutableObservableValue(...path) {
        return this.#object.createMutableObservableValue(...path);
    }
    subscribeAll(observer) {
        return this.#object.subscribeAll(observer);
    }
    terminate() { this.#terminator.terminate(); }
}
